export default ($stateProvider) => {
  $stateProvider
    .state('uc-license-msg', {
      url: `${location.pathname}uc-license-error`,
      template: '<nets-uc-license-msg></nets-uc-license-msg>',
    });
};
